import { postExchangeAccessToken } from './exchange-access-token';
import { postGenerateShortTermToken } from './generate-short-term-token';
import { postGetThirdPartyRedirect } from './get-ninespokes-redirect';

export const getLongTermToken = postExchangeAccessToken;

export const getShortTermToken = postGenerateShortTermToken;

export const get9SpokesRedirectURL = postGetThirdPartyRedirect;
